// Angular
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
// Service
import { LayoutRenderService } from '../../../../services/layout-render.service';
// Model
import { PublicRecordModel } from '../model/public-record-model.interface';
import { UIConfigComponent, UIConfigService, UIConfigStyle } from '@cv-invision/core';

@Component({
	selector: 'cv-public-record-single',
	templateUrl: './public-record-single.component.html',
	styleUrls: ['./public-record-single.component.scss']
})
export class PublicRecordSingleComponent implements OnInit, OnChanges {

	@Input() publicRecordType: string;

	public dataOpen = false;
	public copiedNotifyOpen = false;
	public deeds: any[] = [];
	public footerStyle: UIConfigStyle = null;

	get publicRecord(): PublicRecordModel {
		return this.layoutRenderService.extraData.publicRecord;
	}

	get publicRecordAddress(): any {
		return this.layoutRenderService.extraData.publicRecordAddress;
	}

	get isEditing(): boolean {
		return this.layoutRenderService.activateEditableUX;
	}

	constructor(
		private layoutRenderService: LayoutRenderService,
		public uiConfigService: UIConfigService
	) {
	}

	ngOnInit(): void {
		this.setDeeds();
		this.footerStyle = this.uiConfigService.getComponentStyle(UIConfigComponent.FOOTER);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['publicRecordType']) {
			this.setDeeds();
		}
	}

	openPanel(): void {
		if (this.deeds.length < 1) {
			this.setDeeds();
		}

		this.dataOpen = !this.dataOpen;
	}

	/**
	 * Event to store in navigator clipboard
	 *
	 * @param value
	 */
	copyToClipboard(value: string) {
		if (value) navigator.clipboard.writeText(value)
	}

	/**
	 * To display the small & quick toaster that informs the
	 * user that his value was successfully copied
	 *
	 * @param event
	 */
	copiedEvent(event: any): void {
		this.copiedNotifyOpen = true;
		setTimeout(() => {
			this.copiedNotifyOpen = false;
		}, 1000);
	}

	/**
	 * Add title & open attributes + Sort the Deeds
	 */
	setDeeds(): void {
		if (this.publicRecord) {
			this.deeds = [];
			if ('mortgageDeeds' in this.publicRecord) {
				this.deeds = this.deeds.concat([...this.publicRecord.mortgageDeeds.map((deed: any) => {
					return { ...deed, title: 'MORTGAGE', open: false }
				})]);
			}

			if ('transferDeeds' in this.publicRecord) {
				this.deeds = this.deeds.concat([...this.publicRecord.transferDeeds.map((deed: any) => {
					return { ...deed, title: 'TRANSFER', open: false }
				})]);
			}
		}

		this.sortDeeds();
	}

	/**
	 * Add title & open attributes + Sort the Deeds
	 */
	sortDeeds(): void {
		this.deeds.sort(function (a: any, b: any) {
			const dateA = new Date(a.recordingDate).getTime();
			const dateB = new Date(b.recordingDate).getTime();

			return dateA > dateB ? -1 : 1;
		});
	}

}
